import { Button, Spinner } from '@nextui-org/react'
import { FC, ReactNode } from 'react'
import { MdOutlineWarning } from 'react-icons/md'
import { TONES } from '../constants'

interface Props {
  loading: boolean
  error: string | null
  onRetry?: () => void
  children: ReactNode
  empty?: boolean
  emptyText?: string
}

/**
 * Pequeño wrapper que muestra spinner/error/empty y, si todo OK, renderiza children.
 * Mantiene consistencia visual entre vistas.
 */
const ApiStateView: FC<Props> = ({ loading, error, onRetry, children, empty, emptyText }) => {
  if (loading) {
    return (
      <div className='py-10 flex items-center justify-center'>
        <Spinner size='lg' color='primary' />
      </div>
    )
  }
  if (error !== null && error !== '') {
    return (
      <div
        className='rounded-xl px-4 py-3 flex items-center gap-3 text-sm border'
        style={{ background: TONES.rosa.bgSoft, borderColor: `${TONES.rosa.ink}4d` }}
      >
        <MdOutlineWarning className='shrink-0 text-xl' style={{ color: TONES.rosa.ink }} />
        <div className='flex-1'>
          <div className='font-semibold' style={{ color: TONES.rosa.ink }}>No se pudo cargar la información</div>
          <div className='text-[14px] text-[#151930]/60 break-all'>{error}</div>
        </div>
        {onRetry !== undefined && (
          <Button size='sm' className='text-white text-xs font-semibold' style={{ background: TONES.rosa.ink }} onPress={onRetry}>
            Reintentar
          </Button>
        )}
      </div>
    )
  }
  if (empty === true) {
    return (
      <div className='py-10 text-center text-sm text-[#151930]/50'>
        {emptyText ?? 'Sin datos para mostrar'}
      </div>
    )
  }
  return <>{children}</>
}

export default ApiStateView
